import { useGlobalData } from '@context/siteContext'

const useModuleSettings = () => {
	const [ globalData ] = useGlobalData()
	return globalData?.moduleSettings || {}
}

export default useModuleSettings
